module.exports = __webpack_public_path__ + "media/images/cart-f72e2774f93be10f73133748965793af.png";